import * as React from "react";
import { forwardRef } from "react";
const SignalIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M12 10.504c.621 0 1.125.504 1.125 1.125a1.12 1.12 0 0 1-.375.837v7.769a.75.75 0 1 1-1.5 0v-7.769a1.12 1.12 0 0 1-.375-.837c0-.621.504-1.125 1.125-1.125zM4.575 4.205a.75.75 0 0 1 1.061 1.061 9 9 0 0 0-.162 12.562l.162.166.052.057a.75.75 0 0 1-1.055 1.055l-.057-.051-.189-.194C.476 14.746.539 8.241 4.575 4.205zm13.789 0a.75.75 0 0 1 1.06 0c4.1 4.1 4.1 10.749 0 14.849l-.057.051a.75.75 0 0 1-1.004-1.112 9 9 0 0 0 0-12.728.75.75 0 0 1 0-1.061zM6.696 6.326a.75.75 0 0 1 1.061 1.061 6 6 0 0 0 0 8.486.75.75 0 0 1-1.061 1.061 7.5 7.5 0 0 1 0-10.607zm9.547 0a.75.75 0 0 1 1.004-.052l.057.052.135.139a7.5 7.5 0 0 1-.135 10.468.75.75 0 0 1-1.061-1.061 6 6 0 0 0 .213-8.261l-.213-.224-.052-.057a.75.75 0 0 1 .052-1.004zm-7.368 2.07a.75.75 0 0 1 1.004 1.112l-.107.112a3 3 0 0 0 0 4.019l.107.112.051.057a.75.75 0 0 1-1.055 1.055l-.057-.051-.159-.168a4.5 4.5 0 0 1 .159-6.196l.057-.052zm5.246.051a.75.75 0 0 1 1.004-.052l.057.052.159.168a4.5 4.5 0 0 1-.159 6.196l-.057.051a.75.75 0 0 1-1.004-1.112l.107-.112a3 3 0 0 0 0-4.019l-.107-.112-.051-.057a.75.75 0 0 1 .051-1.004z"
}));
const ForwardRef = forwardRef(SignalIcon);
export default ForwardRef;